
<div class="d-flex align-items-center pr-10">
  <span class="fs-12 bold mr-8 flex-0">Find:</span>
  <input type="text" class="trg-outline h-24 lh-30 fs-12 flex-grow"
    [formControl]="filterCtrl"
    placeholder="Enter Text" />
</div>

<div class="overflow-y-auto pr-10 mb-12 scroller p-relative">
  <div>
    <span [hidden]="anyCategoryVisible">No matches found.</span>
    @for (cs of categoryStates; track cs.id) {
    <div class="category" [hidden]="cs.hidden()">
      <div class="category-title">
        <div class="d-inline-flex align-items-center">
          <i *ngIf="cs.category.iconClass" class="i-20 {{cs.category.iconClass}}"></i>
          <img *ngIf="cs.category.iconUrl" [src]="cs.category.iconUrl" class="h-20 w-auto" [alt]="cs.category.title" />
          <span class="bold text-ellipsis pr-10 ml-4">{{cs.category.title}} ({{cs.visibleItemCount()}})</span>
        </div>
        <div class="category-collapse-btn" (click)="toggleCollapsed(cs)">
          <i class="far {{cs.collapsed() ? 'fa-plus' : 'fa-minus'}} i-14"></i>
        </div>
      </div>
      <div class="category-items" [hidden]="cs.collapsed() || cs.hidden()">
        @for (gs of cs.groupStates; track gs.id) {
        <div class="group" [hidden]="gs.hidden()">
          <div class="group-title">
            <span class="bold text-ellipsis pr-10">{{gs.group.title}} ({{gs.visibleItemCount()}})</span>
            <div class="group-collapse-btn" (click)="toggleCollapsed(gs)">
              <i class="far {{gs.collapsed() ? 'fa-plus' : 'fa-minus'}} i-14"></i>
            </div>
          </div>
          <div class="group-items" [hidden]="gs.collapsed() || gs.hidden()">
            @for (is of gs.itemStates; track is.id) {
            <div class="item" [hidden]="is.hidden()" [class.selected]="is.selected()" (click)="setSelectedItem(cs, gs, is)">
              <span class="text-ellipsis pr-20">
                <text-highlight [text]="is.item.title" [pattern]="filterPattern"></text-highlight>
              </span>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
